export default "__VITE_ASSET__CaCVXIwx__"